import React from 'react'
import styled from 'styled-components';

const Styles = styled.div`
    div {
        width: 100%;
        height: 100vh;
        max-height: 100vh;
        background-color: olivedrab;
    }
`;

class Portfolio extends React.Component {
    render() {
        return (
            <Styles>
                <div id='portfolio'>
                    <span>This is a span in the portfolio section</span>
                    <a href='#about'>About page</a><br></br>
                    <a href='#hero'>Hero page</a>
                </div>
                {/* <div>This is a div in the portfolio</div> */}
            </Styles>
        )
    }
}

export default Portfolio;
